export default "__VITE_ASSET__BEjMNp3x__"